'use strict';

import {$document} from '../utilities/_helpers'

$document.on('click', '[data-js="search-clear"]', function() {
    $('[data-js="search"]').val('');
});
